import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import {
  parseAnswers,
  normalizeRates,
  RecentRoundResultsSummary,
  ReadOnlyBetChoiceCardPC,
} from './PreBetRoundPreviewShared';

function PreBetRoundPreviewPC({ viewProps }) {
  const choices = useMemo(() => parseAnswers(viewProps?.round?.answers), [viewProps?.round?.answers]);
  const rates = useMemo(
    () => normalizeRates(viewProps?.roundRateData ?? viewProps?.round?.rates ?? viewProps?.round?.odds, choices),
    [choices, viewProps?.round?.odds, viewProps?.round?.rates, viewProps?.roundRateData],
  );
  const choiceColumnCount = Math.min(Math.max(choices.length, 2), 4);

  return (
    <Box sx={{ display: 'grid', gap: 1.25, mb: 1.5 }}>
      <RecentRoundResultsSummary
        results={viewProps?.recentRoundResults}
        targetNumbers={viewProps?.recentRoundResultTargetNumbers}
        choices={choices}
        maxResults={10}
        rangeLabel="直近10ラウンド"
      />
      {choices.length >= 2 ? (
        <Box>
          <Box sx={{ mb: 0.75, fontSize: '12px', color: 'rgba(15, 23, 42, 0.72)', fontWeight: 900 }}>
            今回の選択肢
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: `repeat(${choiceColumnCount}, minmax(0, 1fr))`,
              gap: choiceColumnCount >= 4 ? 0.75 : 1,
            }}
          >
            {choices.map((choice, index) => (
              <ReadOnlyBetChoiceCardPC
                key={`${choice}-${index}`}
                choice={choice}
                index={index}
                rate={rates?.[index]}
              />
            ))}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
}

export default PreBetRoundPreviewPC;
